import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { SipIdentity } from '@ragu-components/ord-types';

const SipIdentitiesList = React.lazy(async () => import('./SipIdentitiesList'));

export const sipIdentitiesResource: OrdResourceProps = {
  key: Resources.sip_identities,
  name: Resources.sip_identities,
  list: <SipIdentitiesList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: SipIdentity): string => `${record.username}`,
};
